module.exports = __webpack_public_path__ + "static/media/suport.d90901fc.svg";